module.exports = "https://web-assets.ifttt.com/packs/media/layout/android_download-753e847e.svg";